module.exports = "<app-navigation></app-navigation>\n<router-outlet></router-outlet>"